<iframe
  class="hangfire-iframe"
  [src]="sanitizer.bypassSecurityTrustResourceUrl(url)"
  width="99%"
  height="99%"
></iframe>
